// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jbft","type":"styles_type__mqXdB","choices":"styles_choices__occvK"};